/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { TranslatorContext, useTranslator } from '@jutro/locale';

import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TwiaPolicyService } from 'ent-capability-policybilling';
import metadata from './PolicyDetailsSummary.metadata.json5';
import DetailsAccordion from '../DetailsAccordion/DetailsAccordion.jsx';
import PolicyDocumentsAccordion from '../PolicyDocumentsAccordion/PolicyDocumentsAccordion.jsx';
import InsuredPropertyDetailsAccordion from '../InsuredPropertyDetailsAccordion/InsuredPropertyDetailsAccordion.jsx';
import PolicyContactsAccordion from '../PolicyContactsAccordion/PolicyContactsAccordion.jsx';
import PolicyCoveragesAccordion from '../PolicyCoveragesAccordion/PolicyCoveragesAccordion.jsx';
import CommercialPolicySummaryDetails from '../CommercialPolicySummaryDetails/CommercialPolicySummaryDetails.jsx';
import messages from './PolicyDetailsSummary.messages.js'
import styles from './PolicyDetailsSummary.module.scss'

const PolicyDetailsSummary = props => {
    const {
        policyCommonDetails,
        updateWritableDocuments,
        writableDocuments,
        isPolicyLevelDoc,
        isRenewal,
    } = props;
    const currentPeriodDetails = !isRenewal ? _.get(policyCommonDetails, 'currentPeriodDetails') : _.get(policyCommonDetails, 'renewedPeriodDetails');
    const policyCommonDocuments = _.get(policyCommonDetails, 'currentPeriodDetails.documentDTOs')
    const hoLobData = _.get(policyCommonDetails, 'currentPeriodDetails.lobs.homeOwners')
    const isDwelling = _.get(hoLobData, 'dwellingDTO.policyType') === 'Dwelling and Personal Property';
    const isTenant = _.get(hoLobData, 'dwellingDTO.policyType') === 'Tenant Personal Property Only';
    const isMH = _.get(hoLobData, 'dwellingDTO.policyType') === 'Manufactured Home';
    const isCondo = _.get(hoLobData, 'dwellingDTO.policyType') === 'Condo Unit Owner'
    const isCommercial = _.get(currentPeriodDetails, 'productName') === 'Commercial'
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const[updatedDocs,setUpdatedDocs] = useState(policyCommonDocuments);
 
    useEffect(() => {
        (async() =>{ 
            if(isPolicyLevelDoc) {
                const policyNumber = _.get(policyCommonDetails, 'currentPeriodDetails.policyNumber')
                const policyDocs = await TwiaPolicyService.getPolicyDocumentsForRoles_TWIA(policyNumber,'PNI',authHeader);
                setUpdatedDocs(policyDocs);              
            } else {
                const offerNumber = _.get(policyCommonDetails, 'currentPeriodDetails.jobNumber_TWIA');
                const policyDocs = await TwiaPolicyService.getJobDocumentsForRoles_TWIA(offerNumber,'PNI',authHeader);
                setUpdatedDocs(policyDocs);  
            } 
    })()
    }, [authHeader, isPolicyLevelDoc, policyCommonDetails]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        policyDetailsSection: {
            value: currentPeriodDetails,
            isCommercial
        },
        policyCoveragesSection: {
            value: currentPeriodDetails
        },
        policyContactsSection: {
            value: currentPeriodDetails
        },
        insuredPropertyDetailsSection: {
            value: currentPeriodDetails,
            hoLobData,
            isDwelling,
            isTenant,
            isMH,
            isCondo
        },
        coveragesAccordion: {
            visible: !isCommercial
        },
        propertyDetailsAccordion: {
            visible: !isCommercial
        },
        commercialLocationAccordion: {
            visible: isCommercial,
            data: currentPeriodDetails

        },
        DocumentsAccordion: {
            title: translator(messages.documentsCount, {
                documentsCount: !_.isUndefined(updatedDocs)
                    ? `(${updatedDocs.length})`
                    : '',
            })
        },
        DocumentsSection: {
            value: {
                documentDTOs: updatedDocs,
                policyNumber: '',
                canUploadDocument: false,
            },
            writableDocuments,
            updateWritableDocuments,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            detailsAccordion: DetailsAccordion,
            policyDocumentsAccordion: PolicyDocumentsAccordion,
            insuredPropertyDetailsAccordion: InsuredPropertyDetailsAccordion,
            policyCoveragesAccordion: PolicyCoveragesAccordion,
            policyContactsAccordion: PolicyContactsAccordion,
            commercialPolicySummaryDetails: CommercialPolicySummaryDetails
        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            //model={submissionVM}
            // onModelChange={updateWizardData}
            // onValueChange={writeValue}
            // showErrors={showErrors}
            // onValidationChange={setComponentValidation}
            // callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

PolicyDetailsSummary.propTypes = wizardProps;
PolicyDetailsSummary.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(PolicyDetailsSummary));
